import React from 'react';
const CCTVHomeServices = () => <div className="service-page"><h1>CCTV & Home Services</h1><p>Secure your home with CCTV and smart home solutions.</p></div>;
export default CCTVHomeServices;
